import KetQuaClsChuyenTuyen from '../../../modals/modal-tab-xu-tri/modal-chuyen-tuyen/KetQuaClsChuyenTuyen';
import BenhVienChuyenTuyen from './BenhVienChuyenTuyen';
import ChanDoanChuyenTuyen from './ChanDoanChuyenTuyen';

interface Props {
    data: any;
}

const CustomComponent = ({ data }: Props) => {

    const Default = () => {
        return <></>;
    };

    const components: { [key: string]: any } = {
        BenhVienChuyenTuyen: BenhVienChuyenTuyen,
        ChanDoanChuyenTuyen: ChanDoanChuyenTuyen,
        KetQuaClsChuyenTuyen: KetQuaClsChuyenTuyen,
    };

    const DynamicContent = components[data?.componentName] || Default;

    const props: Record<string, any> = {
        KetQuaClsChuyenTuyen: {
            visitId: data?.customProps?.visitId
        }
    };

    return <DynamicContent {...data} {...props[data?.componentName]} />;
};

export default CustomComponent;
